import AboutController from "./AboutController";

export default AboutController;
